import React, { useContext, useState, useRef } from "react";
import { Button, Col, Container, Form, FormFeedback, FormGroup, FormText, Input, Label, Row } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import 'flatpickr/dist/themes/material_green.css';
import { addQuery, uploadQueryFile } from "helpers/UAM/inquiry.helper";
import ToastDialog from "common/ToastDialog";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { SystemConfigurationContext } from "context/systemConfigContext";
const AddOrEditQuery = () => {

    const title = "Query"
    document.title="Query | DMS"
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const { inputMax } = useContext(SystemConfigurationContext)

    const navigate = useNavigate();

    async function handleFormSubmit(values) {
        setIsBtnLoading(true);
        const res = await addQuery({ query: values.productInfo });
        if (res.status) {
            setToastInfo({ message: res.message, showToast: true, role: "success" });
            navigate("/customer/query");
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false);
    }

    const formikInitialValues = {
        productInfo: [
            {
                'id': 1,
                'description': '',
                'file': []
            }
        ],
    };

    const formikValidationSchema = Yup.object().shape({
        productInfo: Yup.array().of(
            Yup.object().shape({
                description: Yup.string().required('Query is required'),
                file: Yup.array().of(Yup.string().required('File is required'))
            })
        ).required('Required'),
    });

    const formik = useFormik({
        initialValues: formikInitialValues,
        validationSchema: formikValidationSchema,
        onSubmit: (values) => handleFormSubmit(values),
    });

    const handleFileUpload = async (e, index) => {
        setIsBtnLoading(true);
        const uploadedFile = e.target.files[0];
        if (!uploadedFile) return;

        const size = uploadedFile.size / 1024 / 1024;

        if (size > 2) {
            setToastInfo({ message: "File size must be less than 2 MB", showToast: true, role: "error" });
            setIsBtnLoading(false);
            const fileInput = window.document.querySelector(`#exampleFile-${index}`);
            fileInput.value = "";
            let productInfo = [...formik.values.productInfo]
            productInfo[index].file = [];
            return;
        }

        const fileUploadApiRes = await uploadQueryFile(uploadedFile);
        if (fileUploadApiRes.status) {
            let productInfo = [...formik.values.productInfo]
            productInfo[index].file = fileUploadApiRes.data
            formik.setFieldValue('productInfo', productInfo)
        } else {
            setToastInfo({ message: fileUploadApiRes.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false);
    }

    const handleFilePreview = (index) => {
        const url = process.env.REACT_APP_IMAGE_URL;
        window.open(`${url}/${formik.values.productInfo[index].file[0]}`, '_blank');
    }

    const handleCancel = () => {
        navigate("/customer/query");
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Col className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0 font-size-18 fixed">{title}</h4>
                        </div>
                    </Col>
                    <Form onSubmit={formik.handleSubmit}>
                        <Row>

                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body my-0">
                                        {formik.values.productInfo.map((product, index) => (
                                            <div key={product.id}>
                                                {index !== 0 && (<div style={{ borderBottom: '0.5px solid #e1e4e8' }}>

                                                </div>)}
                                                <Row >
                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <Label className="mb-1 required">Enter your query</Label>
                                                            <Input
                                                                maxLength={inputMax}
                                                                type="textarea"
                                                                placeholder="Enter your query"
                                                                className={`${formik.touched.productInfo?.[index]?.description &&
                                                                    formik.errors.productInfo?.[index]?.description
                                                                    ? "is-invalid"
                                                                    : ""}`}
                                                                name={`productInfo.[${index}].description`}
                                                                id={`productInfo.[${index}].description`}
                                                                value={formik.values?.productInfo[index]?.description}
                                                                onChange={formik.handleChange}
                                                                invalid={formik.touched.productInfo?.[index]?.description && formik.errors.productInfo?.[index]?.description}
                                                            />
                                                            {formik.touched.productInfo?.[index]?.description &&
                                                                formik.errors.productInfo?.[index]?.description && (
                                                                    <FormFeedback>
                                                                        {formik.errors.productInfo?.[index]?.description}
                                                                    </FormFeedback>
                                                                )}
                                                        </div>
                                                    </Col>

                                                    <Col sm={12} lg={6} xl={6} md={6}>
                                                        <div className="mb-3">
                                                            <FormGroup>
                                                                <Label className=" mb-1">Upload File</Label>
                                                                <Input accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx .odt, .ods, .odp, .csv" onChange={(e) => handleFileUpload(e, index)} type="file" className="d-block" name="file" id={`exampleFile-${index}`} />
                                                                {!isEmpty(formik.values?.productInfo[index]?.file[0]) ? <FormText color="muted">
                                                                    <p className="text-success mt-2 fs-6" onClick={() => handleFilePreview(index)} style={{
                                                                        cursor: "pointer",
                                                                    }}>View</p>
                                                                </FormText> : <FormText color="muted">
                                                                    You can upload files in JPEG, PDF, Excel, and word formats, with a maximum size limit of 2 MB
                                                                </FormText>}
                                                            </FormGroup>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="d-flex align-items-center justify-content-end">
                                    <Button outline color="secondary" type="submit" className="w-md mt-3 me-2" onClick={handleCancel}>
                                        Cancel
                                    </Button>
                                    <Button color="success" type="submit" className="w-md mt-3" disabled={isBtnLoading || formik.values.productInfo.length == 0}>
                                        {isBtnLoading && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </Row>
                    </Form>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
        </React.Fragment>
    )
}

export default AddOrEditQuery